import React from 'react';
import { Check, X, ShieldCheck, Zap } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { motion } from 'framer-motion';
import { OfferSelector } from './OfferSelector';
export function Pricing() {
  return <section id="pricing" className="py-12 md:py-20 bg-white" data-id="element-159">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-160">
        {/* Comparison */}
        <div className="mb-16 md:mb-24" data-id="element-161">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-8 md:mb-12" data-id="element-162">
            <h2 className="text-2xl md:text-4xl font-extrabold text-slate-900 mb-2 md:mb-4" data-id="element-163">
              LA REALIDAD
            </h2>
            <p className="text-base md:text-xl text-slate-600" data-id="element-164">
              ¿Cuánto cuesta NO tenerlo?
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-slate-50 rounded-3xl overflow-hidden border border-slate-200" data-id="element-165">
            <div className="grid md:grid-cols-2" data-id="element-166">
              <div className="p-6 md:p-10 bg-white" data-id="element-167">
                <h3 className="text-lg md:text-xl font-bold text-slate-900 mb-4 md:mb-6 flex items-center gap-2" data-id="element-168">
                  <X className="w-5 h-5 md:w-6 md:h-6 text-red-500" data-id="element-169" /> Sin el
                  sistema
                </h3>
                <ul className="space-y-4 md:space-y-6" data-id="element-170">
                  <li className="flex gap-2 md:gap-3 text-sm md:text-base text-slate-600" data-id="element-171">
                    <X className="w-4 h-4 md:w-5 md:h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-172" />
                    <span data-id="element-173">
                      Horas subrayando el Lorenzetti sin saber qué entra
                    </span>
                  </li>
                  <li className="flex gap-2 md:gap-3 text-sm md:text-base text-slate-600" data-id="element-174">
                    <X className="w-4 h-4 md:w-5 md:h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-175" />
                    <span data-id="element-176">Estudiar temas que no pregunta el profe</span>
                  </li>
                  <li className="flex gap-2 md:gap-3 text-sm md:text-base text-slate-600" data-id="element-177">
                    <X className="w-4 h-4 md:w-5 md:h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-178" />
                    <span data-id="element-179">
                      Bloquearte en el oral sin saber cómo estructurar la
                      respuesta
                    </span>
                  </li>
                  <li className="flex gap-2 md:gap-3 text-sm md:text-base text-slate-600" data-id="element-180">
                    <X className="w-4 h-4 md:w-5 md:h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-181" />
                    <span data-id="element-182">
                      Resolver casos prácticos sin saber por dónde empezar
                    </span>
                  </li>
                  <li className="flex gap-2 md:gap-3 text-sm md:text-base text-slate-600" data-id="element-183">
                    <X className="w-4 h-4 md:w-5 md:h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-184" />
                    <span data-id="element-185">Llegar al parcial sin saber cuánto te falta</span>
                  </li>
                  <li className="flex gap-2 md:gap-3 text-sm md:text-base text-slate-600" data-id="element-186">
                    <X className="w-4 h-4 md:w-5 md:h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-187" />
                    <span data-id="element-188">Recursarla otra vez</span>
                  </li>
                </ul>
              </div>
              <div className="p-6 md:p-10 bg-brand-50 border-t md:border-t-0 md:border-l border-brand-100" data-id="element-189">
                <h3 className="text-lg md:text-xl font-bold text-brand-900 mb-4 md:mb-6 flex items-center gap-2" data-id="element-190">
                  <Check className="w-5 h-5 md:w-6 md:h-6 text-brand-600" data-id="element-191" /> Con
                  el sistema
                </h3>
                <ul className="space-y-4 md:space-y-6" data-id="element-192">
                  <li className="flex gap-2 md:gap-3 text-sm md:text-base text-brand-800" data-id="element-193">
                    <Check className="w-4 h-4 md:w-5 md:h-5 text-brand-600 flex-shrink-0 mt-0.5" data-id="element-194" />
                    <span data-id="element-195">
                      <strong className="font-semibold" data-id="element-196">
                        30 minutos de repaso
                      </strong>{' '}
                      con las fichas de artículos
                    </span>
                  </li>
                  <li className="flex gap-2 md:gap-3 text-sm md:text-base text-brand-800" data-id="element-197">
                    <Check className="w-4 h-4 md:w-5 md:h-5 text-brand-600 flex-shrink-0 mt-0.5" data-id="element-198" />
                    <span data-id="element-199">
                      Solo los 50 artículos y temas con{' '}
                      <strong className="font-semibold" data-id="element-200">
                        mayor peso en el parcial
                      </strong>
                    </span>
                  </li>
                  <li className="flex gap-2 md:gap-3 text-sm md:text-base text-brand-800" data-id="element-201">
                    <Check className="w-4 h-4 md:w-5 md:h-5 text-brand-600 flex-shrink-0 mt-0.5" data-id="element-202" />
                    <span data-id="element-203">
                      <strong className="font-semibold" data-id="element-204">
                        Método de 4 pasos
                      </strong>{' '}
                      para responder cualquier pregunta con seguridad
                    </span>
                  </li>
                  <li className="flex gap-2 md:gap-3 text-sm md:text-base text-brand-800" data-id="element-205">
                    <Check className="w-4 h-4 md:w-5 md:h-5 text-brand-600 flex-shrink-0 mt-0.5" data-id="element-206" />
                    <span data-id="element-207">
                      Método de 5 pasos +{' '}
                      <strong className="font-semibold" data-id="element-208">
                        20 casos resueltos
                      </strong>{' '}
                      con artículos
                    </span>
                  </li>
                  <li className="flex gap-2 md:gap-3 text-sm md:text-base text-brand-800" data-id="element-209">
                    <Check className="w-4 h-4 md:w-5 md:h-5 text-brand-600 flex-shrink-0 mt-0.5" data-id="element-210" />
                    <span data-id="element-211">
                      <strong className="font-semibold" data-id="element-212">
                        Cronograma día a día
                      </strong>{' '}
                      con lo que estudiar cada sesión
                    </span>
                  </li>
                  <li className="flex gap-2 md:gap-3 text-sm md:text-base text-brand-800" data-id="element-213">
                    <Check className="w-4 h-4 md:w-5 md:h-5 text-brand-600 flex-shrink-0 mt-0.5" data-id="element-214" />
                    <span data-id="element-215">
                      Sistema completo para{' '}
                      <strong className="font-semibold" data-id="element-216">
                        aprobar en este cuatrimestre
                      </strong>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Pricing */}
        <div className="mb-20" data-id="element-217">
          <div className="text-center mb-10" data-id="element-218">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-100 text-red-700 font-bold text-sm mb-6 animate-pulse" data-id="element-219">
              <Zap className="w-4 h-4" data-id="element-220" /> Oferta en vivo +$10.000 DESCUENTO
            </div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4" data-id="element-221">
              Elegí tu Megapack Método de Estudio
            </h2>
            <p className="text-xl text-slate-600 mb-8" data-id="element-222">
              Ambas opciones incluyen los 6 bonus estratégicos completos
            </p>

            <div className="mb-8" data-id="element-223">
              <p className="text-sm font-bold text-slate-500 uppercase tracking-wider mb-3" data-id="element-224">
                LANZAMIENTO TERMINA EN
              </p>
              <CountdownTimer data-id="element-225" />
              <p className="text-sm text-slate-500 mt-3" data-id="element-226">
                Y no vuelve a bajar • Cupos restantes{' '}
                <span className="font-bold text-red-500" data-id="element-227">68% TOMADOS</span>
              </p>
            </div>
          </div>

          <OfferSelector variant="light" data-id="element-228" />
        </div>

        {/* What Full Pack Adds */}
        <div className="mb-20 bg-slate-50 rounded-3xl p-8 md:p-12 border border-slate-200" data-id="element-229">
          <div className="text-center mb-10" data-id="element-230">
            <h2 className="text-3xl font-extrabold text-slate-900 mb-4" data-id="element-231">
              ¿QUÉ AGREGA EL PACK FULL?
            </h2>
            <p className="text-xl text-slate-600" data-id="element-232">
              Para estudiantes que quieren aprobar con nota y entender la
              materia de verdad
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-233">
            <div data-id="element-234">
              <div className="text-brand-600 font-bold mb-2" data-id="element-235">01 / 04</div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-236">
                Rompé el círculo de recursar
              </h3>
              <p className="text-slate-600 mb-6" data-id="element-237">
                Recursaste Contratos y no entendés por qué seguís sin aprobar
              </p>

              <div className="space-y-4" data-id="element-238">
                <div className="bg-white p-4 rounded-xl border border-red-100" data-id="element-239">
                  <div className="flex items-center gap-2 text-red-600 font-bold mb-1" data-id="element-240">
                    <X className="w-4 h-4" data-id="element-241" /> Sin Pack Full
                  </div>
                  <p className="text-sm text-slate-600" data-id="element-242">
                    Seguís estudiando con los mismos apuntes y métodos que ya no
                    te funcionaron antes.
                  </p>
                </div>
                <div className="bg-white p-4 rounded-xl border border-brand-200 shadow-sm" data-id="element-243">
                  <div className="flex items-center gap-2 text-brand-600 font-bold mb-1" data-id="element-244">
                    <Check className="w-4 h-4" data-id="element-245" /> Con Pack Full
                  </div>
                  <p className="text-sm text-slate-600" data-id="element-246">
                    Sistema completo con autoevaluadores, simulacros y plan de
                    estudio personalizado para identificar exactamente qué te
                    falla y cómo corregirlo.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-slate-900 rounded-2xl p-8 text-white" data-id="element-247">
              <h4 className="font-bold text-xl mb-6 text-brand-400" data-id="element-248">
                PACK FULL INCLUYE:
              </h4>
              <ul className="space-y-4" data-id="element-249">
                <li className="flex items-start gap-3" data-id="element-250">
                  <Check className="w-5 h-5 text-brand-500 flex-shrink-0 mt-0.5" data-id="element-251" />
                  <span className="text-slate-300" data-id="element-252">
                    Acceso prioritario a actualizaciones de contenido cuando el
                    CCCN cambie
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-253">
                  <Check className="w-5 h-5 text-brand-500 flex-shrink-0 mt-0.5" data-id="element-254" />
                  <span className="text-slate-300" data-id="element-255">
                    Simulacros adicionales de parcial y oral con corrección
                    detallada
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-256">
                  <Check className="w-5 h-5 text-brand-500 flex-shrink-0 mt-0.5" data-id="element-257" />
                  <span className="text-slate-300" data-id="element-258">
                    Plan de estudio personalizado según la cantidad de días que
                    tenés hasta el parcial
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-259">
                  <Check className="w-5 h-5 text-brand-500 flex-shrink-0 mt-0.5" data-id="element-260" />
                  <span className="text-slate-300" data-id="element-261">
                    Guía de cómo pedir revisión de nota y ejercer tus derechos
                    como estudiante
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Guarantee */}
        <div className="bg-green-50 rounded-3xl p-8 md:p-12 border border-green-200 flex flex-col md:flex-row items-center gap-8 max-w-4xl mx-auto" data-id="element-262">
          <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-263">
            <ShieldCheck className="w-12 h-12 text-green-600" data-id="element-264" />
          </div>
          <div data-id="element-265">
            <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-266">
              7 DÍAS GARANTÍA TOTAL
            </h3>
            <p className="text-lg text-slate-700 mb-4" data-id="element-267">
              7 días para probarlo o te devolvemos el 100%
            </p>
            <p className="text-slate-600" data-id="element-268">
              Abrís los tomos, probás los bonus con tus apuntes y el CCCN. Si no
              es lo que esperabas: sin preguntas, sin formularios, sin drama.
            </p>
            <p className="text-sm font-bold text-green-700 mt-4" data-id="element-269">
              Tasa de devoluciones menor al 0.1%
            </p>
          </div>
        </div>
      </div>
    </section>;
}